var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[(_vm.type === 'html')?_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitizeContent(_vm.content) )}}):_vm._e(),(_vm.type === 'img')?_c('v-responsive',{staticClass:"iframe-container"},[_c('iframe',{staticClass:"iframe",attrs:{"src":_vm.content,"sandbox":""}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }